export default "__VITE_ASSET__DaEdXWhA__"